export const tableSortDirections = {
  ASC: 'asc',
  DESC: 'desc',
  NONE: 'none',
} as const

export type TableSortDirections =
  typeof tableSortDirections[keyof typeof tableSortDirections]

export const tableVariants = {
  DEFAULT: 'default',
  DS: 'ds',
  FLAT: 'flat',
} as const

export type TableVariants = typeof tableVariants[keyof typeof tableVariants]
